import Cookies from 'js-cookie'
import { getLanguage, setLocale } from '../../assets/languages/index'
import { applicationConfiguration } from '../../api/api'
import { setItemToLocalstorage } from '../../../utils/package-localstorage'
const app = {
  state: {
    sidebar: true,
    device: 'desktop',
    theme: '',
    layout: '',
    contentWidth: '',
    fixedHeader: false,
    fixSiderbar: false,
    autoHideHeader: false,
    color: null,
    weak: false,
    multiTab: true,
    language: getLanguage(),
    abpConfig: null,
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
      //Cookies.set('language', language)
      setItemToLocalstorage("language", language);
    },
    SET_ABPCONFIG: (state, abpConfig) => {
      state.abpConfig = abpConfig
    },
  },
  actions: {
    setSidebar({ commit }, type) {
      commit('SET_SIDEBAR_TYPE', type)
    },
    CloseSidebar({ commit }) {
      commit('CLOSE_SIDEBAR')
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    ToggleTheme({ commit }, theme) {
      commit('TOGGLE_THEME', theme)
    },
    ToggleLayoutMode({ commit }, mode) {
      commit('TOGGLE_LAYOUT_MODE', mode)
    },
    ToggleFixedHeader({ commit }, fixedHeader) {
      if (!fixedHeader) {
        commit('TOGGLE_FIXED_HEADER_HIDDEN', false)
      }
      commit('TOGGLE_FIXED_HEADER', fixedHeader)
    },
    ToggleFixSiderbar({ commit }, fixSiderbar) {
      commit('TOGGLE_FIXED_SIDERBAR', fixSiderbar)
    },
    ToggleFixedHeaderHidden({ commit }, show) {
      commit('TOGGLE_FIXED_HEADER_HIDDEN', show)
    },
    ToggleContentWidth({ commit }, type) {
      commit('TOGGLE_CONTENT_WIDTH', type)
    },
    ToggleColor({ commit }, color) {
      commit('TOGGLE_COLOR', color)
    },
    ToggleWeak({ commit }, weakFlag) {
      commit('TOGGLE_WEAK', weakFlag)
    },
    ToggleMultiTab({ commit }, bool) {
      commit('TOGGLE_MULTI_TAB', bool)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    applicationConfiguration({ commit },lang) {
      return new Promise(resolve => {
        applicationConfiguration({ LanguageName: lang }).then(res => {
          if (res.success) {
            setLocale(lang, res.result)
          }
          resolve(res)
        })
   
      })
       
    },
  }
}
export default app
